<template>
  <!-- <nav>
    <router-link to="/">Home</router-link>
  </nav> -->
  <div class="menu" style="background-color: rgba(0, 0, 0, 0.2);">
    <div class="xzy_logo_text" @click="goPage('/')">
      <img style="width: 50px" src="@/assets/images/logo.png" />
      <span style="font-size: 16px;color: #fff;margin-left: 10px;">海南易联新能源技术有限公司</span>
    </div>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :ellipsis="false"
      @select="handleSelect" active-text-color="#4eb878" background-color="none" text-color="#fff">
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/关于我们">关于我们</el-menu-item>
      <el-menu-item index="/主营业务">主营业务</el-menu-item>
      <el-menu-item index="/产品中心">产品中心</el-menu-item>
      <el-menu-item index="/核心优势">核心优势</el-menu-item>
      <el-menu-item index="/合作伙伴">合作伙伴</el-menu-item>
    </el-menu>
  </div>
  <!-- style="margin-top: 60px;" -->
  <div>
    <router-view />
    <div class="introduce">
      <div class="introduce_item">
        <div class="pettyb_small_title" style="display: flex;align-items: center;">
          <img src="@/assets/images/Rectangle.png" alt="" style="width: 46px;height: 26px;">
          <span style="margin-left: 10px;font-size: 18px;color: #000;"> 海南易联新能源技术有限公司</span>
        </div>
        <div style="width: 300px;font-size: 14px;color: #000;">专注新能源领域，为客户提供高效、稳定的设备供应与供应链管理服务，助力双碳目标实现。</div>
      </div>
      <div class="introduce_item">
        <div class="pettyb_small_title" style="font-size: 18px;color: #000;">快速链接</div>
        <div @click="handleSelect('/关于我们')" style="cursor: pointer;color: #000;">关于我们</div>
        <div @click="handleSelect('/主营业务')" style="cursor: pointer;color: #000;">主营业务</div>
        <div @click="handleSelect('/产品中心')" style="cursor: pointer;color: #000;">产品中心</div>
        <div @click="handleSelect('/核心优势')" style="cursor: pointer;color: #000;">核心优势</div>
        <div @click="handleSelect('/合作伙伴')" style="cursor: pointer;color: #000;">合作伙伴</div>
      </div>
      <div class="introduce_item">
        <div class="pettyb_small_title" style="font-size: 18px;color: #000;">联系信息</div>
        <div style="font-size: 14px;color: #000;">
          <div><i class="iconfont icon-address" style="margin-right: 10px;"></i>地址：海南省三亚市天涯区三亚中央商务区凤凰岛1号楼A座2035号</div>
          <div><i class="iconfont icon-dianhua" style="margin-right: 10px;"></i>电话：0898-88886777</div>
          <div><i class="iconfont icon-hulianwang" style="margin-right: 10px;"></i>邮箱：hnyl_xny@163.com</div>
        </div>
      </div>
    </div>
    <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 20px;" class="count_box">
      <el-icon style="color: #4eb878;">
        <View />
      </el-icon>
      <span style="margin-left: 5px;font-size: 14px;color: #4eb878;">本站总浏览量：{{ apiCount }} 次</span>
    </div>
    <div class="copyright">Copyright © 2023~2025 海南易联新能源技术有限公司 版权所有 <span class="beian"> 琼ICP备2025062956号-1</span></div>
    <!-- @click="goProduct('https://beian.miit.gov.cn')" -->
  </div>


</template>
<script setup>
import { ref, reactive, onMounted, onUnmounted, getCurrentInstance, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from 'axios';
const router = useRouter();
const route = useRoute();
const now_route_path = ref('/')
const activeIndex = ref('/')
const handleSelect = (key, keyPath) => {
  // console.log(key, keyPath)
  // router.push({ path: key })
  if (key === '/') {
    window.scrollTo(0, 0)
  }
  else if (key === '/关于我们') {
    window.scrollTo(0, 710)
  }
  else if (key === '/主营业务') {
    window.scrollTo(0, 1200)
  }
  else if (key === '/产品中心') {
    window.scrollTo(0, 1800)
  }
  else if (key === '/核心优势') {
    window.scrollTo(0, 3000)
  }
  else if (key === '/合作伙伴') {
    window.scrollTo(0, 3500)
  }

  console.log('2222', key, keyPath);

}
const deviceScreen = ref(3)//1小屏幕设备 2中等屏幕设备 3大屏幕设备
const isMobile = ref(2) // 是否是移动端 1是 2否
watch(
  () => route.path, // 监听 route.path 的变化
  (newPath) => {
    activeIndex.value = newPath
    now_route_path.value = newPath
  }
);
onMounted(() => {

  if (checkMobile()) {
    console.log('This is a mobile device');
    isMobile.value = 1
  } else {
    console.log('This is a desktop device');
    isMobile.value = 2
  }
  localStorage.setItem("xzy_isMobile", isMobile.value);
  window.addEventListener('resize', updateScreenWidth);
  updateScreenWidth()
  fetchCount()
})

const apiCount = ref(0)
const apiLoading = ref(false)
const apiError = ref('')
const fetchCount = async () => {
  try {
    apiLoading.value = true
    apiError.value = ''

    const response = await axios.get('https://dev-core.pettyb.com/b/count')

    if (response.data && response.data.code === 1) {
      apiCount.value = response.data.result
      console.log('API调用成功，count值:', apiCount.value)
    } else {
      apiError.value = 'API返回数据格式异常'
      console.error('API返回数据格式异常:', response.data)
    }
  } catch (error) {
    apiError.value = 'API调用失败: ' + error.message
    console.error('API调用失败:', error)
  } finally {
    apiLoading.value = false
  }
}

onUnmounted(() => {
  // 组件销毁时移除监听器
  window.removeEventListener('resize', updateScreenWidth);
})
const loading = ref(false)
function updateScreenWidth() {
  const width = window.innerWidth; // 获取当前窗口宽度
  // 根据宽度执行逻辑
  if (width < 600) {
    deviceScreen.value = 1
    console.log('小屏幕设备');
  } else if (width >= 600 && width < 1024) {
    console.log('中等屏幕设备');
    deviceScreen.value = 2
  } else {
    console.log('大屏幕设备');
    deviceScreen.value = 3
  }
}
const goPage = (path, index) => {
  activeIndex.value = path
  router.push({ path })
  window.scrollTo(0, 0)
}
const checkMobile = () => {
  const userAgent = navigator.userAgent;
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
const goProduct = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}
</script>

<style scoped>
/* 手机 */
@media screen and (max-width: 600px) {
  .menu {
    padding: 0;
  }

  .introduce {
    padding: 0 20px;
    width: 1440px;

  }

  .count_box {
    width: 1440px;
  }

  .copyright {
    padding: 0 20px;
    width: 1440px;
  }
}

/* 平板 */
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .menu {
    padding: 0;
  }

  .introduce {
    /* padding: 0 20px; */
    width: 1440px;
  }

  .count_box {
    width: 1440px;
  }

  .copyright {
    padding: 0 20px;
    width: 1440px;
  }
}

/* 桌面 */
@media screen and (min-width: 1025px) {
  .menu {
    padding: 0 100px;
  }

  .introduce {
    /* padding: 0 20px; */
    width: 80%;
  }
}

.menu {
  position: fixed;
  top: 0;
  /* background-color: #fff; */
  /* width: 100%; */
  left: 0;
  right: 0;
  z-index: 9999;

  display: flex;
  justify-content: space-between;
  /* border-bottom: 1px solid #eee; */
}

.el-menu--horizontal.el-menu {
  border-bottom: none
}

.el-menu--horizontal>.el-menu-item {
  margin-right: 0;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus {
  background-color: #ff8f0010;
  color: #4eb878
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
  background-color: #ff8f0010;
  color: #4eb878;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


.xzy_logo_text {
  /* width: 100px; */
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 360px;
}

.code_img {
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.introduce {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin: 40px auto;
  background-color: #fff;
}

.introduce_item {
  font-size: 13px;
  color: #a7a7a7;
  line-height: 2.3;
}

.introduce_title {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}

.copyright {
  font-size: 13px;
  color: #a7a7a7;
  text-align: center;
  margin-bottom: 40px;

}

.beian {
  cursor: pointer;
}

.beian:hover {
  color: #409eff
}

.code_box {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;

}

.code_box div {
  text-align: center;
}
</style>
